export default {"list":"AVEj3","cols3":"iDXNX","item":"TqSdM","pagination":"gU7mx"};